import { apiFetch } from './client';

export interface ResellerBrandingRow {
  reseller_id: string;
  brand_name: string;
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  email_from_name: string | null;
  email_from_addr: string | null;
  sms_sender_name: string | null;
  kb_welcome_md: string | null;
  updated_at: string;
}

export interface PutBrandingBody {
  brand_name: string;
  logo_url?: string | null;
  favicon_url?: string | null;
  primary_color?: string | null;
  secondary_color?: string | null;
  email_from_name?: string | null;
  email_from_addr?: string | null;
  sms_sender_name?: string | null;
  kb_welcome_md?: string | null;
  reseller_id?: string;
}

export const resellerBranding = {
  get: () =>
    apiFetch<{ branding: ResellerBrandingRow | null }>('/api/reseller-branding'),
  getForReseller: (id: string) =>
    apiFetch<{ branding: ResellerBrandingRow | null }>(`/api/resellers/${id}/branding`),
  put: (body: PutBrandingBody) =>
    apiFetch<ResellerBrandingRow>('/api/reseller-branding', {
      method: 'PUT', body: JSON.stringify(body),
    }),
};
